import NextLink from 'next/link';

import {AnimatedText, Button} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import * as css from './PendingKitHeader.css';

export const PendingKitHeader = () => (
  <>
    <div
      className={sprinkles({
        colSpan: [4, 6],
        colStart: [1, 2],
        content: 'center',
        flex: ['flex', 'flex', 'none'],
        pB: 64,
      })}>
      <video autoPlay className={css.video} loop muted playsInline>
        <source
          src="https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/dashboard/progress-tracker.mp4"
          type="video/mp4"
        />
      </video>
    </div>

    <div
      className={sprinkles({
        colSpan: [4, 6, 4],
        colStart: [1, 2],
        dir: 'col',
        flex: 'flex',
        gap: 32,
      })}>
      <AnimatedText color="inherit" variant="heading2">
        We are calculating your TallyAge™
      </AnimatedText>

      <AnimatedText color="inherit">We’ll notify you when your results are ready.</AnimatedText>

      <NextLink href="/dashboard" passHref>
        <Button
          as="a"
          className={sprinkles({w: ['full', 'full', 'maxContent']})}
          icon="ArrowRight"
          variant="primary-dark">
          View test tracker
        </Button>
      </NextLink>
    </div>

    <div
      className={sprinkles({
        colSpan: 5,
        colStart: 7,
        content: 'end',
        flex: ['none', 'none', 'flex'],
      })}>
      <video autoPlay className={css.video} loop muted playsInline>
        <source
          src="https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/dashboard/progress-tracker.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </>
);
